<template>
  <div
    role="button"
    tabindex="0"
    @click="goLink()"
    :class="textColor + ' grid-item' + (comingSoon ? ' comingSoon' : ' ')"
  >
    <b-card :title="title" :bg-variant="color">
      <p :class="'m-0 ' + textColor">{{ subTitle }}</p>
      <span class="tag" v-if="comingSoon">{{ 'Em breve' }}</span>

      <footer class="bg-question mb-2 mt-2" :style="imgBg">
        <img
          :src="imgIcon"
          :alt="'imagem de animação do card ' + title"
          :class="{ chrome: isChrome }"
        />
      </footer>
    </b-card>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
    },
    subTitle: {
      type: String,
      required: false,
    },
    color: {
      type: String,
      required: false,
    },
    route: {
      type: Object,
      required: false,
      default: undefined,
    },
    img: {
      type: String,
      required: false,
    },
    textColor: {
      type: String,
      required: false,
      default: 'text-gray',
    },
    textSubTitleColor: {
      type: String,
      required: false,
      default: 'text-gray',
    },
    comingSoon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isChrome: false,
    }
  },
  computed: {
    imgIcon: function() {
      return '/home/dashboard/img-widget-' + this.img + '.svg'
    },
    imgBg: function() {
      if (this.img === 'custom-question-off') return ''
      return (
        "background-image: url('/home/dashboard/bg-widget-" +
        this.img +
        ".svg')"
      )
    },
  },
  methods: {
    goLink: function() {
      if (this.route) {
        this.$router.push(this.route)
      }
    },
  },
  mounted: function() {
    this.isChrome = navigator.userAgent.indexOf('Chrome') !== -1
  },
}
</script>

<style scoped lang="scss">
@import '~@/styles/custom/colors';

.card {
  border-radius: 8px;
  border: none !important;
  box-shadow: none;
  transition: all ease 0.3s;
  width: 248px;
  float: left;
  top: 0px;
  cursor: pointer;

  .card-body {
    @media (max-width: 425px) {
      padding: 0.8rem;
    }
  }

  .card-title {
    margin: 0px;
    font-size: 28px;
    font-weight: 500;
  }

  @media (max-width: 560px) {
    width: 210px;
  }
  @media (max-width: 480px) {
    width: 190px;
    .card-title {
      font-size: 19px;
    }
  }
  @media (max-width: 425px) {
    width: 180px;
  }
  @media (max-width: 420px) {
    width: 160px;
    .card-title {
      font-size: 17px;
    }
  }
  @media (max-width: 374px) {
    width: 132px;
    .card-title {
      font-size: 13px;
    }
  }
  @media (max-width: 319px) {
    width: 125px;
    .card-title {
      font-size: 11px;
    }
  }
}

.text-white {
  .card-title {
    color: white;
  }
  .p {
    color: white;
  }
}

.comingSoon {
  .card {
    cursor: default;
    border: 1px solid rgba(0, 0, 0, 0.125) !important;
    top: 0px !important;
    background-color: map-get($theme-colors, 'light');
  }

  .card-title {
    color: map-get($theme-colors, 'gray01');
  }

  .bg-question {
    background-image: none;
  }

  .tag {
    background-color: red;
    color: white;
    border-radius: 30px;
    font-size: 11px;
    padding: 1px 6px;
    width: fit-content;
    width: -moz-fit-content;
    width: -ms-fit-content;
    margin: 10px 0px !important;
  }

  img {
    transform: translate(10px, 0px) scale(0.7) !important;
    -ms-transform: translate(10px, 0px) scale(0.5) !important;

    &.chrome {
      transform: translate(10px, 0px) scale(1) !important;
    }

    @media (max-width: 768px) {
      transform: translate(10px, 0px) scale(0.6) !important;
      -ms-transform: translate(10px, 0px) scale(0.4) !important;

      &.chrome {
        transform: translate(10px, 0px) scale(0.9) !important;
      }
    }
  }
}

.card:before {
  display: block;
  color: white;
  padding-top: 0.2em;
  text-align: center;
  font-size: 1.4rem;
}

.bg-question {
  background-repeat: no-repeat;
  margin: 0px;
}

footer {
  overflow: hidden;
  height: 210px;
  display: flex;
  justify-content: center;

  @media (max-width: 425px) {
    height: 110px;
  }
  @media (max-width: 375px) {
    height: 100px;
  }
  @media (max-width: 374px) {
    height: 80px;
  }

  img {
    display: block;
    transition: all ease-in-out 0.2s;
    transform: scale(0.7);
    -ms-transform: scale(0.5);

    &.chrome {
      transform: scale(1);
    }

    @media (max-width: 768px) {
      transform: scale(0.6) !important;
      -ms-transform: scale(0.4) !important;

      &.chrome {
        transform: scale(0.9) !important;
      }
    }
  }
}

.grid-item {
  margin: 15px;

  @media (max-width: 768px) {
    margin: 10px;
  }
  @media (max-width: 425px) {
    margin: 5px;
  }
  @media (max-width: 320px) {
    margin: 3px;
  }
}

.grid-item:hover {
  .card {
    top: -16px;

    @media (max-width: 768px) {
      top: 0px;
    }
  }

  img {
    transform: scale(0.9);
    -ms-transform: scale(0.7);

    &.chrome {
      transform: scale(1.2);
    }

    @media (max-width: 768px) {
      transform: scale(0.6);
      -ms-transform: scale(0.4);

      &.chrome {
        transform: scale(0.9);
      }
    }
  }
}

p {
  color: map-get($theme-colors, 'gray04');
  line-height: 1rem;
  font-size: 0.8rem;
  @media (max-width: 425px) {
    font-size: 0.7rem;
  }
  @media (max-width: 374px) {
    font-size: 0.6rem;
  }
}
</style>
